export default __webpack_public_path__ + "static/media/wysensing.9f1ff91f.png";